import * as React from "react";
import { styled } from "@mui/material";
import { MobileView } from "../../../util/aKaunGeneralUtil";

//region [[ Styles ]]

const LandingPageImageView = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  width: "50%",
  [theme.breakpoints.down(MobileView)]: {
    width: "100%",
    marginTop: "17px",
  },
  "& svg": {
    marginBottom: "-397px",
    [theme.breakpoints.down(MobileView)]: {
      height: "400px",
      marginBottom: "-280px",
    },
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface LandingPageImageProps {
  className?: string;
  // todo: figure out exactly what type is ReactComponent
  Image: any;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const LandingPageImage = ({
  Image,
  ...props
}: LandingPageImageProps) => {
  return (
    <LandingPageImageView className={props.className}>
      <Image />
    </LandingPageImageView>
  );
};
